<template>
  <component :is="component" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
  export default {
    props: {
      path: {
        type: String,
        required: true
      },
    },
    data() {
      return {
        component: null,
      };
    },
    async created() {
      this.component = await this.loadComponent();
    },
    methods: {
      async loadComponent() {
        try {
          const domain = String(this.$domain.current().slug).toUpperCase();
          return (await import(`./Domains/${domain}/${this.path}.vue`)).default;
        } catch (e) {
          try {
            return (await import(`./${this.path}.vue`)).default;
          } catch {
            console.error('UNKNOWN COMPONENT PATH!');
            return null;
          }
        }
      }
    }
  }
</script>
